"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewExtraCarryOn = function NewExtraCarryOn() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.8077 20C7.30898 20 6.88302 19.825 6.52982 19.475C6.17661 19.125 6 18.707 6 18.2211V6.70193C6\n5.81346 6.28333 5.03525 6.85 4.3673C7.41667 3.69935 8.13333 3.27756 9\n3.10193V1H11.5V3H15.5V1H18V3.10193C18.8666 3.27756 19.5833 3.69935 20.15 4.3673C20.7166 5.03525 21\n5.81346 21 6.70193V18.2211C21 18.707 20.8233 19.125 20.4701 19.475C20.1169 19.825 19.691 20 19.1922\n20H7.8077ZM7.8077 18.5H19.1922C19.282 18.5 19.3557 18.4727 19.4134 18.4183C19.4711 18.3638 19.5\n18.298 19.5 18.2211V6.70193C19.5 6.09423 19.2801 5.57531 18.8404 5.14518C18.4006 4.71504 17.8705\n4.49998 17.25 4.49998H9.75C9.12948 4.49998 8.59935 4.71504 8.1596 5.14518C7.71985 5.57531 7.49997\n6.09423 7.49997 6.70193V18.2211C7.49997 18.298 7.52882 18.3638 7.58652 18.4183C7.64423 18.4727\n7.71795 18.5 7.8077 18.5Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.52982 23.0134C3.88302 23.3634 4.30898 23.5384 4.8077 23.5384H12.75C13.1642 23.5384 13.5\n23.2027 13.5 22.7885C13.5 22.3742 13.1642 22.0385 12.75 22.0385H4.8077C4.71795 22.0385 4.64423\n22.0112 4.58652 21.9567C4.52882 21.9022 4.49997 21.8365 4.49997 21.7596V14.75C4.49997 14.3358\n4.16419 14 3.74999 14C3.33578 14 3 14.3358 3 14.75V21.7596C3 22.2455 3.17661 22.6634 3.52982\n23.0134Z",
    fill: "#6E6D71"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "9",
    y: "11",
    width: "9",
    height: "2",
    fill: "#6E6D71"
  }));
};
var _default = NewExtraCarryOn;
exports.default = _default;